import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useContentStore } from "@/store/content";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomCursor',
  setup(__props) {

const cursor = ref<HTMLDivElement | null>(null);

const addListeners = () => {
  document.addEventListener("mousemove", (e) => {
    setCursor(e);
    setClickable(e);
  });

  document.onmousedown = () => {
    addClick();
  };

  document.onmouseup = () => {
    removeClick();
  };
};

const setCursor = ({ clientX, clientY }: MouseEvent) => {
  if (!cursor.value) return;

  const offset = useContentStore().vmin(5);
  const insideLeft = clientX > offset;
  const insideRight = clientX < innerWidth - offset;

  if (insideLeft && insideRight) {
    cursor.value.style.left = clientX + "px";
  } else {
    if (insideRight) {
      cursor.value.style.left = clientX + (offset - clientX) + "px";
    }
    if (insideLeft) {
      cursor.value.style.left =
        clientX + (innerWidth - offset - clientX) + "px";
    }
  }

  const insideTop = clientY > offset;
  const insideBottom = clientY < innerHeight - offset;

  if (insideTop && insideBottom) {
    cursor.value.style.top = clientY + "px";
  } else {
    if (insideBottom) {
      cursor.value.style.top = clientY + (offset - clientY) + "px";
    }
    if (insideTop) {
      cursor.value.style.top =
        clientY + (innerHeight - offset - clientY) + "px";
    }
  }
};

const setClickable = ({ target }: MouseEvent) => {
  if (
    target instanceof HTMLElement &&
    (target.classList.contains("clickable") || target.tagName === "A")
  ) {
    addClick();
  } else {
    removeClick();
  }
};

const addClick = () => {
  cursor.value?.classList.add("click");
};

const removeClick = () => {
  cursor.value?.classList.remove("click");
};

addListeners();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "custom-cursor",
    ref_key: "cursor",
    ref: cursor
  }, null, 512))
}
}

})